import { render, staticRenderFns } from "./DeletedАctivities.vue?vue&type=template&id=0b955d62"
import script from "./DeletedАctivities.vue?vue&type=script&lang=js"
export * from "./DeletedАctivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports